var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.getOfferLink()}},[_vm._v(_vm._s(_vm.$getTextMainSetting(
    'footerMenuOfferLinkText',
    _vm.$t('components.pages.contacts.offerLinkTitle')
  )))])}
var staticRenderFns = []

export { render, staticRenderFns }